import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=51ddaea7&scoped=true"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddaea7",
  null
  
)

export default component.exports